import React, { useState, useEffect } from 'react';
import './EditGrowthHackModal.scss';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const statusOptions = [
  // { value: '', label: 'Select Status' },
  { value: 'In assessment', label: 'In assessment' },
  { value: 'Converted into Opportunity', label: 'Converted into Opportunity' },
  { value: 'Move to Backlog', label: 'Move to Backlog' },
  { value: 'Archived', label: 'Archived' },
  { value: 'New', label: 'New' },
];

const reasonOptions = [
  { value: 'Available as Opportunity', label: 'Available as Opportunity' },
  { value: 'Not an opportunity to pursue', label: 'Not an opportunity to pursue' },
  { value: 'Client is not interested', label: 'Client is not interested' },
  { value: 'Duplicate Entry', label: 'Duplicate Entry' },
  { value: 'Others', label: 'Others' },
];

export default function EditGrowthHackModal({ open, onClose, onSubmit, initialStatus = '', initialReason = '', growthHackId = '' }) {
  const [status, setStatus] = useState(initialStatus || '');
  const [reason, setReason] = useState(initialReason);
  const [customReason, setCustomReason] = useState('');
  const [errors, setErrors] = useState({ reason: '', customReason: '' });

  useEffect(() => {
    if (open) {
      setStatus(initialStatus || '');
      setReason(initialReason || '');
      setCustomReason('');
  setErrors({ reason: '', customReason: '' });
    }
  }, [open, initialStatus, initialReason]);

  const handleReasonChange = (e) => {
    const selectedReason = e.target.value;
    setReason(selectedReason);
    if (selectedReason !== 'Others') {
      setCustomReason('');
    }
    // Clear errors on change
    setErrors(prev => ({ ...prev, reason: '', customReason: '' }));
  };

  const handleStatusChange = (e) => {
    const nextStatus = e.target.value;
    setStatus(nextStatus);
    if (nextStatus !== 'Archived') {
      setReason('');
      setCustomReason('');
      setErrors({ reason: '', customReason: '' });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = { reason: '', customReason: '' };
    if (status === 'Archived') {
      if (!reason) {
        validationErrors.reason = 'Reason is required when status is Archived';
      } else if (reason === 'Others' && !customReason.trim()) {
        validationErrors.customReason = 'Please specify a reason';
      }
    }

    setErrors(validationErrors);
    if (validationErrors.reason || validationErrors.customReason) {
      return; // Block submit until fixed
    }
    const finalReason = reason === 'Others' ? customReason : reason;
    onClose();
    const payload = status === 'Archived' ? { status, reason: finalReason } : { status };
    onSubmit(payload);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="edit-growth-hack-modal" sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <Box className="modal-header">
          <Typography variant="h6">Edit Growth Hack</Typography>
          <Button className="close-btn" onClick={onClose}>
            &#10005;
          </Button>
        </Box>
        <form onSubmit={handleSubmit}>
          <Box className="modal-content">
            <Box className="form-group">
              <Typography className="label">Change Status</Typography>
              <TextField
                select
                value={status}
                onChange={handleStatusChange}
                variant="outlined"
                className="status-select"
                fullWidth
                InputProps={{ style: { color: '#fff' } }}
                
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value} style={{ color: '#fff'}}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box className="form-group">
              <Typography className="label">Reason for Archived</Typography>
              <TextField
                select
                value={reason}
                onChange={handleReasonChange}
                variant="outlined"
                className="status-select"
                fullWidth
                disabled={status !== 'Archived'}
                InputProps={{ style: { color: '#fff' } }}
                error={status === 'Archived' && Boolean(errors.reason)}
                helperText={status === 'Archived' ? errors.reason : ''}
                
              >
                {reasonOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value} style={{ color: '#fff'}}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              {status === 'Archived' && reason === 'Others' && (
                <TextField
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  variant="outlined"
                  multiline
                  rows={3}
                  className="reason-input"
                  fullWidth
                  disabled={status !== 'Archived'}
                  placeholder="Please specify..."
                  style={{ marginTop: '16px' }}
                  InputProps={{ style: { color: '#fff' } }}
                  error={status === 'Archived' && reason === 'Others' && Boolean(errors.customReason)}
                  helperText={status === 'Archived' && reason === 'Others' ? errors.customReason : ''}
                />
              )}
            </Box>
          </Box>
          <Box className="modal-actions">
            <Button onClick={onClose} className="cancel-btn" variant="outlined">
              Cancel
            </Button>
            <Button type="submit" className="submit-btn" variant="contained">
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}
